import { todayNodeName } from "motw_core/Repositories/WorkflowRepository";
import * as React from "react";
import { LoadPanel } from "source/app/presentation/Shared/ActivePanel/Helpers/LoadPanel";
import { EPanelId } from "source/app/services/Shared/EPanelId";
import { Sounds } from "source/app/services/Sound/Sounds";
import UI from "source/app/services/UI/UI";
import { StyleClass } from "source/app/presentation/Shared/Styles/CSS";
import { TouchActionButton } from "source/app/presentation/Shared/TouchActionButton/TouchActionButton";
import { TodayWorkflowNodeIcon } from "../TodayWorkflowNodeIcon";

export function NextActionLink() {
    return (
        <span data-tip="Make a move">
            <TouchActionButton
                ariaLabel="Make a move"
                className={StyleClass(`todayWorkflowLink`, {
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    opacity: 0.95,
                    cursor: "pointer",
                    lineHeight: 0,
                    transition: "transform 140ms ease, filter 140ms ease, opacity 140ms ease",
                    ":hover": {
                        transform: "translateY(-1px) scale(1.04)",
                        filter: "brightness(1.08) saturate(1.04) drop-shadow(0 0 7px rgba(255, 206, 92, 0.2))",
                    },
                    ":active": {
                        transform: "translateY(1px) scale(0.98)",
                        filter: "brightness(0.96) saturate(0.98) drop-shadow(0 0 3px rgba(255, 206, 92, 0.12))",
                    },
                })}
                onActivate={() => {
                    Sounds.wooden_tap.Play({ allowConcurrent: true, volume: 0.6 });
                    GoToWorkflowNodeForInput(todayNodeName);
                }}
            >
                <TodayWorkflowNodeIcon />
            </TouchActionButton>
        </span>
    );
}

export function GoToWorkflowNodeForInput(nodeName: string | undefined) {
    if (nodeName) {
        LoadPanel(EPanelId.Workflows, {
            goToNode: nodeName,
        });
    }

    UI.FocusOnElement("calcTarget_searchNodes");
}
